export const homeDomainErrors = {
  home_domain: '',
}

export const defaultHomeDomain = {
  home_domain: '',
}
